(function(angular, module) {var ChangeLogService, responseItem, responseItems, scopeOptions;

scopeOptions = ['everyone', 'ybusa', 'program'];

scopeOptions.everyone = 'Everyone';

scopeOptions.ybusa = 'YouthBuild Global Staff and Coaches';

scopeOptions.program = 'Program Staff';

ChangeLogService = function($http, ApiUrl, momentConvertFilter, moment, $templateCache) {
  'ngInject';
  var combinePublishedDate, root_url, service;
  service = this;
  root_url = ApiUrl.partial('change_log');
  this.scopeOptions = scopeOptions;
  this.getAuthors = function() {
    return $http.get(root_url('authors')).then(function(response) {
      var i, ids, len, ref, staff;
      ids = [];
      ids.names = {};
      ref = response.data.items;
      for (i = 0, len = ref.length; i < len; i++) {
        staff = ref[i];
        ids.push(staff.id);
        ids.names[staff.id] = staff.name;
      }
      return ids;
    });
  };
  this.index = function(params) {
    if (params == null) {
      params = {};
    }
    return $http.get(root_url(), {
      params: params
    }).then(responseItems).then(momentConvertFilter);
  };
  this.get = function(id) {
    return $http.get(root_url(id)).then(responseItem).then(momentConvertFilter);
  };
  this.templateUrl = function(change) {
    var change_id;
    change_id = change.id || change;
    return root_url(change_id, 'template.html');
  };
  this.create = function(data) {
    combinePublishedDate(data);
    return $http.post(ApiUrl('change_log'), data).then(responseItem).then(momentConvertFilter);
  };
  this.patch = function(item, data) {
    combinePublishedDate(data);
    return $http.patch(root_url(item.id), data).then(responseItem).then(momentConvertFilter).then(function(newData) {
      $templateCache.remove(service.templateUrl(item));
      angular.copy(newData, data);
      return data;
    });
  };
  this["delete"] = function(item) {
    return $http["delete"](root_url(item.id));
  };
  combinePublishedDate = function(data) {
    var date;
    if ((data.published == null) && (data.published_date != null) && (data.published_time != null)) {
      date = moment(data.published_date);
      date.hour(data.published_time.hour());
      date.minute(data.published_time.minute());
      date.startOf('minute');
      data.published = date;
    }
    return data;
  };
};

responseItem = function(r) {
  return r.data.item;
};

responseItems = function(r) {
  return r.data.items;
};

module.service('ChangeLogService', ChangeLogService);
})(angular, angular.module("changeLog"));